import ReactGA from 'react-ga4';

export const initGA = () => {
    const id = process.env.REACT_APP_PUBLIC_GA_TRACKING_ID;
    if (!id) {
        console.warn('Google Analytics ID not found.');
        return;
    }
    ReactGA.initialize(id);
};

export const trackPageview = (path: string) => {
    ReactGA.send({ hitType: 'pageview', page: path });
};

export const trackEvent = (params: {
    category: string;
    action: string;
    label?: string;
    value?: number;
}) => {ReactGA.event(params);};